import React from "react";
import { useNavigate } from "react-router-dom";
// reactsrap
import { Table, Card, CardBody, CardHeader, Nav, NavItem, NavLink } from "reactstrap";
// routes
import routes from "../routes";

const ReportsList = () => {
  const navigate = useNavigate();

  const displayReportListing = (route) => {
    return (
      <tr key={route.path}>
        <td className='align-middle'>{route.name}</td>
        <td className='align-middle'>
          <Nav className="nav-pills-circle" id="tabs_2" pills>
            <NavItem>
              <NavLink
                href='#'
                onClick={() => {
                  navigate(`/admin${route.path}`);
                }}
              >
                <span className="nav-link-icon d-block">
                  <i className='ni ni-bold-right' />
                </span>
              </NavLink>
            </NavItem>
          </Nav>
        </td>
      </tr>
    );
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      console.log(prop.path.split("/"));

      if (prop.path.split("/")[1] === "reports" && prop.path !== "/reports") {
        return (
          displayReportListing(prop)
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <Card className='shadow-lg'>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h3 className='mb-0'>Current Reports</h3>
        </CardHeader>
        <CardBody className="p-0">
          <Table responsive striped>
            <thead className='table-dark'>
              <tr>
                <th scope='col'>Name</th>
                <th scope='col'>Action</th>
              </tr>
            </thead>
            <tbody>{getRoutes(routes)}</tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default ReportsList;
